'use strict';

const Google = require('../../../../providers/stores/Google');

const	ComponentFactory	= require('factories/Component')
, React 			= require('react')
, style 			= require('./loginform.style')
, AuthService		= require('services/AuthService')
, GeoLocation		= require('services/GeoLocation')
, UserService		= require('services/User')
, UserStore 		= require('stores/User')
, ChatService		= require('services/Chat')
, NotificationService		= require('services/Notification')
, GoogleStore		= require('stores/Google')
, CountryStore 		= require('stores/Country')
, RegistrationStore	= require('stores/Registration')
, Form				= require('modules/decorators/form/form')
, Input				= require('modules/decorators/form/input')
, Button			= require('modules/decorators/form/button')
, PopupTermCondition = require('modules/components/popup/termcondition')
, CommonHelper 		= require('peons/Common')
, DatalayerHelper 	= require('peons/Datalayer')
, GoogleSDK 		= require('./google-sdk')
, Cookie			= CommonHelper.isWindow() ? require('js-cookie'): undefined
;

module.exports = ComponentFactory.create({
	displayName : 'LoginForm',
	construct : function({props,context}) {
		this.state = {
			buttonState : ''
		}
	},
	componentDidMount : function(){
		this.AuthService = this.context.manager.addService(AuthService);
		this.UserService = this.context.manager.addService(UserService);
		this.ChatService = this.context.manager.addService(ChatService);
		this.NotificationService = this.context.manager.addService(NotificationService);

		this.context.manager.addStore(UserStore);
		this.context.manager.addStore(CountryStore);
		this.context.manager.addStore(GoogleStore);
		this.initGoogle();
	},
	methods : {
		getCountryOfOrigin : function(){
			this.context.manager
			.addService(GeoLocation)
			.detect().then((res)=>{
				this.context.manager.services.geolocation.dispatch({
					type : 'USER_COUNTRY_OF_ORIGIN',
					payload : res.geoLocation.country.data.id
				})
			});
		},
		trackLogin: function(attr, fail, success) {
			let user_id = 0;
			let country = null;
			let email = '';
			let mobile_no = 0;

			if(attr && attr.user) {
				if(attr.user.contacts && attr.user.contacts.data.length) {
					mobile_no = attr.user.contacts.data.find(c => c.name.toLowerCase() == 'mobile');
					mobile_no = mobile_no.detail.replace(/ /g, '');
				}

				let firstName = attr.user.fullName.split(' ')[0];
				let lastName = attr.user.fullName.split(' ').slice(1).join(' ');
				
				user_id = attr.user.id;
				country = attr.user.countryOfOrigin && attr.user.countryOfOrigin.data.name;
				email = attr.user.account.data.email;
			}
		},
		loginCallback : function(result) {
			const _this = this;
			_this.props.dispatchUserLogin(result);
			setTimeout(() => {
				// _this.UserService.getTotalUnreadMessages();
				const _uuid = result.user && result.user.account.data.uuid || result.vendor.account.data.uuid,
					_accountId = result.user && result.user.accountId
				
				_this.UserService.getUserHildaStatus().then((response)=>{
					if (response.hilda && response.hilda.bwcUser && response.hilda.bwcUser.data.uuid) {
						_this.ChatService.getHildaMessageUnreadCount({
							uuid: response.hilda.bwcUser.data.uuid
						});
					}
				});

				_this.ChatService.getMessageUnreadCount({
					uuid: _uuid
				});

				this.trackLogin(result, '', true);

				_this.NotificationService.getNotificationUnreadCount(_accountId);
				_this.UserService.getWeddingPoints().then((response)=>{
					this.manager.dispatch({
						type : 'WEDDING_POINTS_GET_SUCCESS',
						payload : response
					})
				});
			}, 200);

		},
		googleLogin: function() {
			return window.google_auth2.requestAccessToken();
		},
		initGoogle : function() {			
			const _this = this;
			
			var authGoogle = function(tokenRespons) {
				let payload = {
					type: 'google',
					promotionalNewsletter: true,
					access_token: tokenRespons.access_token || null
				}
				
				_this.setState({
					buttonState : 'btn-loading'
				})

				_this.AuthService.socmedLogin(payload).then((result)=>{
					if(result.status) {
						_this.context.manager.addStore(RegistrationStore);
						_this.props.dispatchRegister({
							fullName : response.name,
							email : response.email || '',
							socmedId : response.id,
							type : 'google',
							access_token: tokenRespons.access_token
						});
						_this.context.parent.onSignUpGoogle &&
						_this.context.parent.onSignUpGoogle();
					} else {
						//REGISTERED
						DatalayerHelper.auth('v2_sign_in', 'google', result);

						_this.loginCallback(result)

						_this.setState({
							buttonState : 'btn-redirecting'
						})

						_this.context.parent.onLoginSuccess &&
						_this.context.parent.onLoginSuccess();
					}

				});
			}

			try {
				GoogleSDK.default(authGoogle);	
			} catch (error) {
				console.error(error, 'err');
			}
		},
		onInvalidLogin : function(data,resetter,invalidate) {
			if(this.state.isReturnInvalid) {
				this.setState({
					isReturnInvalid : false
				},()=>{
					let _email = this.refs.email,
						_form = this.refs.myform.refs.form;

					_email.setValue(_email.getValue());

					setTimeout(function(){
						_form.submit();
					},0)
				})
			}
		},
		basicLogin : function(data,resetter,invalidate) {

			if(this.state.buttonState === 'btn-loading') return;

			this.setState({
				buttonState : 'btn-loading'
			})

			//OR you can call it by displayName : this.context.manager.services.authenticate
			this.AuthService.basicLogin({
				email : data.email,
				password : data.password
			}).then((result)=>{
				if(result.status) {
					this.setState({
						buttonState : ''
					})
					if(result.status === 401) {
						if(result.code === 5) {
							invalidate({
								email : '',
								password : this.translator.toText( 'login.login_label_email_and_password_dont_match' ) //result.message
							});

							this.setState({
								isReturnInvalid : true
							})
						} else if(result.code === 4) {
							//CHANGE ROUTE TO REGISTER
							this.context.manager.addStore(RegistrationStore);
							this.props.dispatchRegister({email : data.email, password: data.password})
							this.context.parent.onSignUpBasic &&
							this.context.parent.onSignUpBasic();
						}
						this.trackLogin(null, result.message, false);

					} else {
						//TODO : TOPBAR NOTIFY SOMETHING WRONG
					}
				} else {

					if(result.user && result.user.account.data.isVerified == 0) {
						this.setState({
							buttonState : ''
						})
						Cookie.set('BS.verification', JSON.stringify({
							token: result.user.sessionId,
							time: null,
							email: result.user.account.data.email
						}), {
							domain: '.bridestory.com', 
							path: '/',
							expires: 1
						});
						let path = '/verification?redirect_uri=' + window.location.pathname;
						window.location.pathname = path;
						// this.context.manager.addStore(RegistrationStore);
						// this.props.dispatchRegister({email : data.email})

						// //CHANGE ROUTE TO VERIFICATION
						// this.context.parent.onVerify &&
						// this.context.parent.onVerify();
						//TODO : TOPBAR NOTIFY
					} else {

						DatalayerHelper.auth('v2_sign_in', 'form', result);

						this.loginCallback(result)

						resetter();

						this.setState({
							buttonState : 'btn-redirecting'
						})

						this.context.parent.onLoginSuccess &&
						this.context.parent.onLoginSuccess();

						Cookie.remove('BS.RedirectURL', {domain: '.bridestory.com', path: '/'})
					}
				}
				return result;
			})
		},
		onTermsConditions : function(e) {
			e.preventDefault();

			this.context.popup &&
			this.context.popup.add(PopupTermCondition,{
				overrideLogin : true
			})
		}
	},
	dispatchToProps : (dispatch)=>{
		return {
			dispatchRegister : function(payload) {
				dispatch({
					type : RegistrationStore.ACTIONS.REGISTRATION_REGISTER,
					payload : payload
				})
			},
			dispatchUserLogin : function(result){
				//ADD RECOGNIZED COUNTRY
				dispatch({
					type : CountryStore.ACTIONS.COUNTRY_ADD,
					payload : result.user && result.user.countryOfOrigin.data || result.vendor.countryOfOrigin.data
				})

				//NOTIFY USER STORE
				dispatch({
					type : UserStore.ACTIONS.USER_LOGIN,
					payload : result
				})

				dispatch({
					type : 'PAGECOUNT_SET',
					payload : 1
				})
			}
		}
	},
	stateToProps : function(state) {
		return {
			googleInit : state.google && state.google.init
		}
	},
	render : function(){
		return (
			<div>
				<div className="row sosmed-connect mt-15 mb-25 f-tac">
					<div className={`col col-12`}>
						<Button onClick={this.googleLogin.bind(this)} className={`btn-block btn-google ready`}>
							<span className="icon-brand-google left">
								<span className="loginform-right-bar" />
							</span>
							Google
						</Button>
					</div>
				</div>
				<div className="loginform-or f-b-12">
					{ this.translator.toHTML( 'login.login_str_or' ) }
				</div>
				<Form className="form" onValidSubmit={this.basicLogin.bind(this)} onInvalidSubmit={this.onInvalidLogin.bind(this)} ref="myform">
					<div className="row">
						<Input type="email" name="email" tabIndex="1" placeholder={this.translator.toText( 'login.login_placeholder_email' )}
							validations="isEmail"
							validationErrors={{isEmail : this.translator.toText( 'login.login_label_wrong_email' ),isDefaultRequiredValue: this.translator.toText( 'login.login_label_no_email' )}}
							ref="email"
							required />
					</div>
					<div className="row">
						<Input type="password" name="password" tabIndex="2" placeholder={this.translator.toText( 'general.label_password' )} validations="minLength:6" validationErrors={{isDefaultRequiredValue:this.translator.toText( 'login.login_label_password_too_short' ),minLength: this.translator.toText( 'login.login_label_password_too_short' )}} required />
					</div>
					{/* <div className="row">
						<p className="f-b-12">
							{ this.translator.toHTML( 'login.login_label_sign_up_note_mobile' ) } <a href={this.getLink('terms-conditions/user')} onClick={this.onTermsConditions.bind(this)} className="f-c-black f-t-u" target="_blank">{ this.translator.toText( 'general.link_tnc' ) }</a>
						</p>
					</div> */}
					<div className="row">
						<div className="col col-6 create-btn wrapper pt-10">
							<Button asButton={true} className={`btn-submit btn-block ${this.state.buttonState}`}>
								{ this.translator.toHTML( 'login.button_continue' ) }
							</Button>
						</div>
					</div>
				</Form>
			</div>
		)
	}
})



// WEBPACK FOOTER //
// resources/modules/components/login/_form.jsx